import styled from 'styled-components';

interface FlexWrapperProps {
  $display?: 'flex' | 'inline-flex';
  $itemAlign?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';
  $justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'normal';
  $direction?: 'row' | 'column';
  $gap?: string;
  $flex?: string;
  $flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  $margin?: string;
  $contain?: boolean;
  $padding?: string;
  $background?: string;
  $borderRadius?: string;
  $maxWidth?: string;
  $minHeight?: string;
  $height?: string;
  $fullHeight?: boolean;
  $fullContent?: boolean;
}

export const FlexWrapper = styled.div<FlexWrapperProps>`
  margin: ${({ $margin }) => $margin || '0px'};
  display: ${({ $display }) => $display || 'flex'};
  align-items: ${({ $itemAlign }) => $itemAlign || 'stretch'};
  justify-content: ${({ $justifyContent }) => $justifyContent || 'flex-start'};
  flex-direction: ${({ $direction }) => $direction || 'row'};
  gap: ${({ $gap }) => $gap || '15px'};
  flex-wrap: ${({ $flexWrap }) => $flexWrap || 'wrap'};
  flex: ${({ $flex }) => $flex || 'auto'};
  padding: ${({ $padding }) => $padding ?? '0px'};
  background-color: ${({ $background }) => $background ?? 'transparent'};
  border-radius: ${({ $borderRadius }) => $borderRadius ?? '0'};
  max-width: ${({ $maxWidth }) => $maxWidth ?? '100%'};
  height: ${({ $height }) => $height ?? 'auto'};
  ${({ $fullHeight }) => $fullHeight && 'height:calc(100vh - 140px)'};
  flex: ${({ $flex }) => $flex || '1'};
  min-height: ${({ $minHeight }) => $minHeight || 'auto'};
  ${({ $fullContent }) => $fullContent && 'flex: 1;'}
`;
